"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.TitlesDefault = void 0;
require("./TitlesDefault.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Link = _interopRequireDefault(require("../Link/Link"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * TitlesDefault component
 *
 * @method
 * @param { TitlesDefaultProps} props
 * @returns TitlesDefault
 */

const TitlesDefault = props => {
  const {
    countLabel,
    externalAction,
    headline,
    headlineTag = defaultProps.headlineTag,
    linkAction,
    subheadline,
    textAlignment
  } = props;
  if (!headline) {
    return null;
  }
  const hasAction = (linkAction === null || linkAction === void 0 ? void 0 : linkAction.label) || externalAction;
  const headlineStyle = textAlignment === 'center' ? 'title-xlg' : 'title-lg';
  const subHeadlineStyle = textAlignment === 'center' ? 'body-lg' : 'body';
  const componentClassName = (0, _classnames.default)('pal-c-TitlesDefault', {
    ["pal-c-TitlesDefault__alignment--".concat(textAlignment)]: textAlignment
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, headline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefault__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefault__body--headline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: headlineStyle,
    htmlTag: headlineTag,
    textAlign: textAlignment,
    textColor: "content-default"
  }, headline)), subheadline && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefault__body--subheadline"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: subHeadlineStyle,
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: "content-default"
  }, subheadline)), countLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefault__body--countLabel"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    textStyle: "body",
    htmlTag: "p",
    textAlign: textAlignment,
    textColor: "xsubtle"
  }, countLabel))), hasAction && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-TitlesDefault__link"
  }, externalAction && (0, _renderObject.renderObject)(externalAction), !externalAction && /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    variant: "primary"
  }, linkAction))));
};

/**
 * Property type definitions
 * @typedef TitlesDefaultProps
 * @type {object}
 * @property {string} countLabel - text for the count
 * @property {object} externalAction - external action object
 * @property {string} headline - headline text of the title
 * @property {string} headlineTag - headline tag of the title
 * @property {object} linkAction - action link for the title
 * @property {string} subheadline - subheadline tag of the title
 * @property {string} textAlignment - align the text (left or center)
 */
exports.TitlesDefault = TitlesDefault;
const propTypes = exports.propTypes = {
  countLabel: _propTypes.default.string,
  externalAction: _propTypes.default.object,
  headline: _propTypes.default.string,
  headlineTag: _propTypes.default.string,
  linkAction: _propTypes.default.object,
  subheadline: _propTypes.default.string,
  textAlignment: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag='h2' - headline tag of the title
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2'
};
TitlesDefault.propTypes = propTypes;
var _default = exports.default = TitlesDefault;